export const RELATIONSHIP_TO_POLICY_HOLDER_OPTIONS = {
  SELF: "Self",
  SPOUSE: "Spouse",
  SIGNIFICANT_OTHER: "Significant other",
  PARENT: "Parent",
  OTHER: "Other",
} as const;
